module.exports = __webpack_public_path__ + "static/media/baseLayer.2553874c.svg";